import React from 'react';
import { Fab, Typography } from '@mui/material';

interface BaseSocialMediaLinkProps {
    link: string;
    icon: React.ReactNode;
}

const BaseSocialMediaLink: React.FC<BaseSocialMediaLinkProps> = ({ link, icon }) => {
    return (
        <Fab size='small' onClick={() => window.open(link)} sx={{ bgcolor: "#fff" }}>
            {icon}
        </Fab>
    )
}

export default BaseSocialMediaLink;